import { getTutorial, putTutorial } from '@/services/appService';

async function getUserTutorialsSeen() {
  return await getTutorial('/tutorial');
}

async function addSeenTutorialStep(tutorialId) {
  return await putTutorial(`/tutorial`, { tutorialId });
}

export default {
  getUserTutorialsSeen,
  addSeenTutorialStep
};
